import React from "react";

interface TabContainerProps {
    header?: string,
    hidden?: boolean,
    dirty?: boolean,
    children?: any
};

class TabContainer extends React.Component<TabContainerProps> {

    header: string;
    hidden: boolean;
    dirty: boolean;
    children?: any;

    constructor(props: TabContainerProps) {
        super(props);

        this.header = props.header ?? "New Tab";
        this.hidden = props.hidden ?? false;
        this.dirty = props.dirty ?? false;
        this.children = props.children;
    }

    render(): React.ReactNode {
        return null;
    }

}

export default TabContainer;